import React, { useEffect, useState } from 'react';
import { useSteps } from '../../hooks/useSteps';
import moment from 'moment';
import { useRouter } from '../../hooks/useRouter';
import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../hooks/useAuth';
import { makeStyles } from '@material-ui/core/styles';
import { Box, CircularProgress } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TooltipIcon from '../../components/TooltipIcon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBitcoin, faEthereum } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import firebase from 'firebase';

const useStyles = makeStyles((theme) => ({
  listItemText: {
    fontSize: 24,
    color: '#627087',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  listItemTextSummary: {
    fontSize: 24,
    fontWeight: 500,
    color: '#2E3542',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  listItemSecondaryAction: {
    fontSize: 24,
    color: '#627087',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  listItemSecondaryActionSummary: {
    fontSize: 24,
    fontWeight: 500,
    color: '#2E3542',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  formControlLabel: {
    marginRight: theme.spacing(6),
  },
  formControlLabelText: {
    fontSize: 24,
  },
}));

const ProlongSummary = (props) => {
  const router = useRouter();
  const api = useApi();
  const auth = useAuth();
  const { t } = useTranslation();
  const classes = useStyles();
  const { capsule, setCapsule } = useSteps();
  const [data, setData] = useState({ capsule: {}, user: {} });
  const [isLoading, setLoading] = useState(true);

  const [paymentMethod, setPaymentMethod] = useState(capsule?.paymentMethod || 'BANK');

  const newStoragePeriodDate = moment(moment.unix(capsule.timeCreated))
    .add(capsule.prolongedStoragePeriod + capsule.storePeriod, 'months')
    .format('D MMMM yyyy');
  // const totalFee = data.capsule?.capsuleFee + data.capsule?.courierFee;
  // const topUpAmount = Math.abs(data?.user?.balance - data?.price?.prolongFee).toFixed(2);
  const topUpAmount =
    Math.abs(data?.user?.balance - data?.price?.prolongFee) > 0 &&
    Math.abs(data?.user?.balance - data?.price?.prolongFee) < 1
      ? Number(1)
      : Math.abs(data?.user?.balance - data?.price?.prolongFee);

  const capsuleId = router.query.id;

  const getData = async () => {
    const responseCapsule = await api.getCapsule(capsuleId);
    const responseUser = await api.getUser();
    const responseRequestedPrice = await api.requestPrice(capsuleId, capsule.prolongedStoragePeriod);

    props.enoughUpdater(responseRequestedPrice.data.userBalance - responseRequestedPrice.data.prolongFee >= 0);

    setData({
      capsule: responseCapsule.data,
      user: responseUser.data,
      price: responseRequestedPrice.data,
    });

    setCapsule({ ...capsule, price: responseRequestedPrice.data });
  };

  console.log(capsule);

  const handleChangePaymentMethod = (event) => {
    setPaymentMethod(event.target.value);
    setCapsule({ ...capsule, paymentMethod: event.target.value });
  };

  const doTopUpBalance = () => {
    if (paymentMethod === 'BANK') {
      props.handleNext();
      setCapsule({ ...capsule, topUpAmount, paymentMethod: 'BANK' });
    } else {
      api
        .addFunds(paymentMethod, Number(topUpAmount))
        .then((response) => {
          setCapsule({ ...capsule, addFunds: response.data });
          props.handleNext();
        })
        .catch((error) => {
          throw new Error(error);
        });
    }
  };

  const doPayCapsule = () => {
    api
      .prolongCapsule(capsuleId, capsule.prolongedStoragePeriod)
      .then(() => {
        props.handleNext();
        setCapsule({ ...capsule, paymentMethod, stepCover: 9 });
      })
      .catch((error) => {
        throw new Error(error);
      });
  };

  useEffect(() => {
    setCapsule({ ...capsule, stepCover: 7 });
    if (auth.isReady) {
      getData().finally(() => {
        setLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  useEffect(() => {
    setCapsule({ ...capsule, paymentMethod, stepCover: 7 });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    firebase.analytics().logEvent('screen_view', { screen_name: '/prolong/summary' });
  }, []);

  return (
    <Box>
      {isLoading ? (
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <CircularProgress color="inherit" size={40} />
        </Box>
      ) : (
        <Box>
          <Grid container spacing={3} direction="column">
            <Grid item xs={12} sm={12}>
              <Box mb={4}>
                <Typography component="h2" variant="h5" style={{ fontWeight: 600, marginBottom: '24px' }}>
                  {t('translation:prolong:title2')}{' '}
                  <TooltipIcon title={t('translation:prolong:title2Tooltip')} placement="top" />
                </Typography>

                <List>
                  <ListItem disableGutters>
                    <ListItemText disableTypography className={classes.listItemText}>
                      {t('translation:prolong:timeToProlongLabel')}
                    </ListItemText>

                    <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
                      <Box textAlign="right">
                        <Box>{data.price.addedPeriod} months</Box>

                        <Typography style={{ fontSize: 16, color: '#A6AAB0', lineHeight: 0.5 }}>
                          {t('translation:common:until')} {newStoragePeriodDate}
                        </Typography>
                      </Box>
                    </ListItemSecondaryAction>
                  </ListItem>

                  <Divider />

                  <ListItem disableGutters>
                    <ListItemText disableTypography className={classes.listItemTextSummary}>
                      {t('translation:prolong:totalLabel')}
                      {data.price.prolongFee > data.user.balance ? (
                        <div
                          style={{
                            fontSize: 18,
                            color: '#B00020',
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                          }}
                        >
                          <InfoOutlinedIcon style={{ marginRight: 8 }} />
                          {t('translation:prolong:notEnoughLabel', {
                            balance: data.user.balance.toFixed(2),
                            fee: data.price.prolongFee.toFixed(2),
                          })}
                        </div>
                      ) : null}
                    </ListItemText>

                    <ListItemSecondaryAction className={classes.listItemSecondaryActionSummary}>
                      $ {data.price.prolongFee.toFixed(2)}
                    </ListItemSecondaryAction>
                  </ListItem>

                  <Divider />

                  {data.price.prolongFee > data.user.balance ? (
                    <ListItem disableGutters>
                      <ListItemText disableTypography className={classes.listItemTextSummary}>
                        {t('translation:prolong:topUpForLabel')}
                      </ListItemText>

                      <ListItemSecondaryAction className={classes.listItemSecondaryActionSummary}>
                        {'$ '}
                        {Math.abs(data?.user?.balance - data?.price?.prolongFee) > 0 &&
                        Math.abs(data?.user?.balance - data?.price?.prolongFee) < 1
                          ? Number(1).toFixed(2)
                          : Math.abs(data?.user?.balance - data?.price?.prolongFee).toFixed(2)}
                      </ListItemSecondaryAction>
                    </ListItem>
                  ) : (
                    <ListItem disableGutters>
                      <ListItemText disableTypography className={classes.listItemTextSummary}>
                        {t('translation:prolong:payFromLabel')}
                      </ListItemText>

                      <ListItemSecondaryAction className={classes.listItemSecondaryActionSummary}>
                        <Box textAlign="right">
                          <Box>
                            {'$ '}
                            {data.price.prolongFee.toFixed(2)}
                          </Box>

                          <Typography style={{ fontSize: 16, color: '#A6AAB0', lineHeight: 0.5 }}>
                            {t('translation:prolong:currentBalanceLabel')} $ {data.user.balance.toFixed(2)}
                          </Typography>
                        </Box>
                      </ListItemSecondaryAction>
                    </ListItem>
                  )}
                </List>
              </Box>

              {data.user.balance - data.price.prolongFee < 0 && (
                <Box>
                  <Typography component="h2" variant="h5" style={{ fontWeight: 600, marginBottom: '24px' }}>
                    {t('translation:prolong:title3')}{' '}
                    <TooltipIcon title={t('translation:prolong:title3Tooltip')} placement="top" />
                  </Typography>

                  <RadioGroup name="paymentMethod" value={paymentMethod} onChange={handleChangePaymentMethod} row>
                    <FormControlLabel
                      className={classes.formControlLabel}
                      value="BANK"
                      control={<Radio color="primary" />}
                      label={
                        <Box display="flex" alignItems="center">
                          <Box mr={1}>
                            <CreditCardIcon />
                          </Box>
                          <Typography className={classes.formControlLabelText} component="div">
                            <Box>{t('translation:prolong:radio1')}</Box>
                          </Typography>
                        </Box>
                      }
                    />

                    <FormControlLabel
                      className={classes.formControlLabel}
                      value="BTC"
                      control={<Radio color="primary" />}
                      label={
                        <Typography className={classes.formControlLabelText} component="div">
                          <Box display="flex" alignItems="center">
                            <Box mr={1}>
                              <FontAwesomeIcon icon={faBitcoin} />
                            </Box>
                            <Box>{t('translation:prolong:radio2')}</Box>
                          </Box>
                        </Typography>
                      }
                    />

                    <FormControlLabel
                      className={classes.formControlLabel}
                      value="ETH"
                      control={<Radio color="primary" />}
                      label={
                        <Typography className={classes.formControlLabelText} component="div">
                          <Box display="flex" alignItems="center">
                            <Box mr={1}>
                              <FontAwesomeIcon icon={faEthereum} />
                            </Box>
                            <Box>{t('translation:prolong:radio3')}</Box>
                          </Box>
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </Box>
              )}

              <Box mt={8}>
                {data.user.balance - data.price.prolongFee < 0 ? (
                  <Button variant="contained" color="primary" size="large" onClick={doTopUpBalance}>
                    {t('translation:common:topUp')}
                  </Button>
                ) : (
                  <Button variant="contained" color="primary" size="large" onClick={doPayCapsule}>
                    {t('translation:common:pay')}
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default ProlongSummary;
